//libs
import React, { useEffect, useRef, useState } from 'react';
//Utils
import { ApiServiceV2 } from 'services';
//Services
import { formatNumber, coinsUtils } from 'utils/libs';
// Components
import { EditIcon, InputNumber, Span, Wrapper } from 'components';
// Hooks
import { useToastMessage } from 'hooks';

const Bonus = ({ rowData, field, value }) => {
	const inputRef = useRef(null);
	const sendToast = useToastMessage();

	const [state, _setState] = useState({
		isEditing: false,
		inputValue: null,
	});

	const setState = newState =>
		_setState(current => ({ ...current, ...newState }));

	const setInputValue = newValue => setState({ inputValue: newValue });

	const coinSymbol = coinsUtils.getDataByCoinId(
		rowData.price?.coinId || rowData.coin_id,
		'symbol',
		rowData.coinsData,
	);

	const toggleEdit = e => {
		e.stopPropagation();
		_setState(current => ({ ...current, isEditing: !current.isEditing }));
	};

	useEffect(() => {
		if (state.isEditing) {
			setInputValue(rowData.bonus >= 0.01 ? rowData.bonus : null);
			inputRef.current?.focus();
		}
	}, [state.isEditing]);

	const submitAmountChange = () => {
		setState({ isEditing: false });
		if (state.inputValue === null || state.inputValue === undefined) return;

		ApiServiceV2.put({
			url: `/payments_orders/${rowData.id}/bonus`,
			data: {
				newBonus: state.inputValue,
				payId: rowData.paymentId,
				paycutId: rowData.paycut_id,
			},
		})
			.then(() => {
				field.refreshRowData?.({
					rowId: rowData.id,
					orderId: rowData.orderId || rowData.order_id,
					newBonus: state.inputValue,
				});
				sendToast({ message: 'Bonus actualizado', type: 'success' });
			})
			.catch(err => sendToast({ message: err.message, type: err.type }));
	};

	const formattedRawValue = formatNumber.new(value, coinSymbol || '', 2);

	return (
		<Wrapper padding='0' margin='0'>
			{state.isEditing ? (
				<InputNumber
					ref={inputRef}
					style={{ width: '100%' }}
					defaultValue={state.inputValue}
					formatter={val =>
						`${coinSymbol} ${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
					}
					onPressEnter={submitAmountChange}
					onBlur={() => setTimeout(() => setState({ isEditing: false }), 0)}
					onChange={setInputValue}
				/>
			) : (
				<Span emphasis maxHeight='200px' overflow='auto'>
					{formattedRawValue}
				</Span>
			)}
			{!field.disableEdit &&
				field.canManageOrders !== false &&
				!rowData.isPaymentSigned &&
				rowData.isPaymentOpen && (
				<EditIcon onClick={toggleEdit} />
			)}
		</Wrapper>
	);
};

export default Bonus;
